import PropTypes from 'prop-types'
import React from 'react'
import FormikDateTimeField from './FormikDateTimeField'

const propTypes = {
  id: PropTypes.string.isRequired,
  showTimezone: PropTypes.bool,
  containerClassName: PropTypes.string,
}

/**
 * @deprecated Prefer {@link FormikDateTimeField} with `useGraphDateTimeOffset`.
 * Stores an ISO-8601 string suitable for Microsoft Graph DateTimeOffset fields.
 */
function FormikGraphDateTimeField({ showTimezone = true, containerClassName = '', ...rest }) {
  return (
    <FormikDateTimeField
      {...rest}
      showTimezone={showTimezone}
      containerClassName={containerClassName}
      useGraphDateTimeOffset
    />
  )
}

FormikGraphDateTimeField.propTypes = propTypes

export default FormikGraphDateTimeField
